export const getUserSetDefaultLocationEndpoint = userId => `User/${userId}:setDefaultLocation`;

